import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SLoader } from '../components/ui/SLoader';

const Loading = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
        navigate('/home');
    }, 3000);

    return () => clearTimeout(timer);
}, [navigate]);

return (  
    <div className="flex flex-col items-center justify-center h-screen bg-white dark:bg-neutral-900">
      <SLoader />
    </div>
);
}

export default Loading;
